import PropTypes from 'prop-types';
import React from 'react';

import localize from 'components/Localize/Localize';
import PropQuote from 'components/PropQuote/PropQuote';
import ValuePropStacked from 'components/ValuePropStacked/ValuePropStacked';

import imageConfig from './imageConfig';
import styles from './Compression.css';
import translations from './translations';

class Compression extends React.Component {
  render() {
    return (
      <ValuePropStacked
        body={this.props.t.body}
        contentClass={styles[`content`]}
        heading={this.props.t.heading}
        imageConfig={imageConfig}
        imageDescription={this.props.t.imageDescription}
        imageName="compression"
      >
        <PropQuote
          icon={this.props.t.quoteIcon}
          quote={this.props.t.quote}
        />
      </ValuePropStacked>
    );
  }
}

Compression.propTypes = {
  t: PropTypes.shape({
    body: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    imageDescription: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired,
    quoteIcon: PropTypes.string.isRequired,
  }).isRequired,
};

export default localize(Compression, translations);
